import axios from 'axios'

export default{
    namespaced: true,
    state: {
        reportTerms: [],        
    },
    getters: {
        getReportTerms(state){
            return state.reportTerms
        },        
    },
    mutations: {
        setReportTerms(state, value){
            state.reportTerms = value
        }
    },
    actions: {
        async getAcademicTerms({ commit }, payload){
            let url = '/api/student-reports/' + payload.id;
            try{
                let response = await axios.get(url);
                console.log(response);
                commit('setReportTerms', response.data);
            } catch (error){
                if(error.response) console.log(error.response)
                else console.log(error);
            }
        }
    }
}